module.exports = __webpack_public_path__ + "static/img/img1.c11fced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img1.png
// module id = GmyW
// module chunks = 1